// extracted by mini-css-extract-plugin
module.exports = {"accountInfoWrapper":"_5qr-uAF1ZAq7ekcCGdKDo","accountInfoInformation":"_2o70RAr8ukjlfOm-F9Ltcj","accountInfoDeleteAccount":"_3X98ND8wStq0l-qtJxnNUD"};